export const MIN_MATURITY_DATE = 1;
export const MAX_MATURITY_DATE = 15;
export const MIN_YEAR_PROFIT = 1;
export const MAX_YEAR_PROFIT = 100;
export const MIN_ROI = 1;
export const MAX_ROI = 100;
